module.exports = __webpack_public_path__ + "img/phone_arrow.fd1ed74f.svg";